import React, { useEffect } from 'react';
import Granim from 'granim';
import {language, LANG_RU, LANG_ARABIA_EN, LANG_ARABIA} from 'Root/constants';

import './bgGradient.scss';

const defaultOptions = {
  element: '#bgGradient',
  direction: language === LANG_RU? 'top-bottom' :'diagonal',
  states: {
    'default-state': {
      gradients: language === LANG_ARABIA || language === LANG_ARABIA_EN ? [
        [
        { color: '#d1d4db', pos: 0.2 },
        { color: '#fff', pos: 0.6 },
        { color: '#d2d5dc', pos: 1 },
      ],
      [
        { color: '#d2d5dc', pos: 0 },
        { color: '#fff', pos: 0.2 },
        { color: '#d1d4db', pos: 0.75 },
      ]
      ]
      : language === LANG_RU ? [
         [
          { color: '#ffffff', pos: 0.2 },
          { color: '#8CA6C7', pos: 0.6 },
          // { color: '#8CA6C7', pos: 1 },
        ]
        // [
        //   { color: '#8da8c6', pos: 0 },
        //   { color: '#e8f1f6', pos: 0.2 },
        //   { color: '#ffffff', pos: 0.75 },
        // ]       
      ]
      : [
        [
          { color: '#ec7700', pos: 0.2 },
          { color: '#fff', pos: 0.6 },
          { color: '#e81f76', pos: 1 },
        ],
        [
          { color: '#e81f76', pos: 0 },
          { color: '#fff', pos: 0.2 },
          { color: '#ec7700', pos: 0.75 },
        ],
      ],
    },
  },
};

const BgGradient = () => {
  useEffect(() => {
    new Granim(defaultOptions);
  }, []);
  return <canvas id="bgGradient"></canvas>;
};

export default BgGradient;
